/* AFTER FOUR v51 / real cart free-shipping progress + purchase shortcut, no tracking. */
(() => {
  'use strict';
  function start() {
    const root = document.querySelector('.af51-pdp');
    if (!root || root.dataset.af51Ready === 'true') return;
    root.dataset.af51Ready = 'true';
    const form = root.querySelector('.af15-form');
    const main = form?.querySelector('button.af15-atc');
    const dock = root.querySelector('[data-af51-dock]');
    const dockButton = dock?.querySelector('[data-af51-dock-add]');
    const dockPrice = dock?.querySelector('[data-af51-dock-price]');
    const bar = root.querySelector('[data-af51-shipping]');
    const threshold = Number(bar?.dataset.threshold || 19900);
    if (!form || !main) return;

    const renderShipping = (paise) => {
      if (!bar || !Number.isFinite(paise)) return;
      const total = Math.max(0, paise);
      const remaining = Math.max(0, threshold - total);
      const roundedRupees = Math.ceil(remaining / 100);
      const text = bar.querySelector('[data-af51-shipping-text]');
      if (text) text.textContent = remaining ? '₹40 DELIVERY BELOW ₹199 · ADD ₹' + roundedRupees + ' FOR FREE DELIVERY' : 'FREE DELIVERY UNLOCKED ON ₹199+ ORDERS';
      const percentage = Math.min(100, Math.round(total / threshold * 100));
      const fill = bar.querySelector('[data-af51-shipping-fill]');
      if (fill) fill.style.width = percentage + '%';
      const track = bar.querySelector('[role="progressbar"]');
      if (track) track.setAttribute('aria-valuenow', String(percentage));
      bar.dataset.cartTotal = String(total);
    };

    const syncPrice = () => {
      if (dockPrice) dockPrice.textContent = root.querySelector('.af15-price strong')?.textContent?.trim() || '';
      if (dockButton) {
        dockButton.disabled = main.disabled;
        dockButton.textContent = main.disabled ? 'SOLD OUT' : 'ADD TO BAG +';
      }
    };
    if (dockButton) dockButton.addEventListener('click', () => {
      if (!main.disabled && form.dataset.af47Busy !== '1') {
        form.requestSubmit(main);
      }
    });
    document.addEventListener('variant:change', () => window.requestAnimationFrame(syncPrice));
    const updateDock = () => {
      if (!dock) return;
      const show = window.matchMedia('(min-width:750px)').matches
        && main.getBoundingClientRect().bottom < 90
        && window.scrollY > 200;
      dock.dataset.active = String(show);
    };
    let ticking = false;
    const schedule = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; updateDock(); });
    };
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule);
    document.addEventListener('af51:cart-updated', (e) => {
      const price = Number(e.detail?.cart?.total_price);
      if (Number.isFinite(price)) renderShipping(price);
    });
    syncPrice();
    renderShipping(Number(bar?.dataset.cartTotal || 0));
    updateDock();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();